import { cn } from "@/lib/utils";

/**
 * Article / industry category chip.
 * Per KS Lau & Co brand guideline §9.4: insights tags use a subtle Gold Sand
 * accent on light backgrounds — not solid navy. Uppercase tracking preserved.
 */

type Props = {
  label: string;
  className?: string;
  size?: "xs" | "sm";
  variant?: "default" | "overlay";
};

export function CategoryPill({ label, className, size = "xs", variant = "default" }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md font-semibold uppercase tracking-wider",
        variant === "overlay"
          ? "bg-gold text-primary shadow-md"
          : "border border-primary/15 bg-primary/8 text-primary",
        size === "xs" ? "px-2.5 py-1 text-[10px]" : "px-3 py-1.5 text-xs",
        className,
      )}
    >
      {label}
    </span>
  );
}
